import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from '@mui/material/CircularProgress';

import Display from 'components/Generic/Display';

function Progress({ progress, loading }) {

  const variant = loading ? 'indeterminate' : 'determinate';

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant={variant} value={progress} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Display if={!loading}>
          <Typography
            variant="body2"
            color="text.secondary"
          >{`${progress}%`}</Typography>
        </Display>
      </Box>
    </Box>
  );
}

Progress.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default React.memo(Progress);
